module.exports = __webpack_public_path__ + "static/media/unlock.e617c1ce.wav";